import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs';
import { ApiResponse } from '../models/api-response.models';
import { unwrapApiResponse } from '../utils/api-response';
import { ApiService } from './api.service';

export interface ReportSummary {
  from: string;
  to: string;
  metrics: Record<string, number>;
  trend: Array<{ date: string; metric: string; value: number }>;
  lastSync?: {
    status: string;
    startedAt: string;
    completedAt?: string;
    metricRows: number;
    error?: string;
  };
}
@Injectable({ providedIn: 'root' })
export class ReportsService {
  private readonly api = inject(ApiService);
  summary(from: string, to: string) {
    return this.api
      .get<ApiResponse<ReportSummary> | ReportSummary>(
        '/reports/summary',
        { from, to },
        'marketplace',
      )
      .pipe(map(unwrapApiResponse));
  }
  sync() {
    return this.api.post('/reports/sync', {}, 'marketplace');
  }
  export(format: 'xlsx' | 'pdf', reportType: string, from: string, to: string) {
    return this.api.download('/reports/export', { format, reportType, from, to }, 'marketplace');
  }
}
